module.exports = __webpack_public_path__ + "img/vedicium.logo.a1b7596c.svg";